export default __webpack_public_path__ + "static/icon-34-3-2e4ca6bcaf6ecb678e404b9e446da19f.png";